import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Logger from '../../../lib/analytics/logger';
import { WELCOME_NEWS_EVENT_TYPES } from '../constants/events';
import { EVENT_ACTIONS, EVENT_DOMAINS, EVENT_SCREENS, EVENT_WIDGETS } from '../../../lib/analytics/constants';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
var buildWelcomeNewsPayload = function buildWelcomeNewsPayload(_ref) {
  var action = _ref.action,
    game = _ref.game,
    externalUrl = _ref.externalUrl,
    campaign_id = _ref.campaign_id,
    message_id = _ref.message_id;
  return {
    action: _objectSpread(_objectSpread(_objectSpread({
      type: action
    }, game && {
      game: game
    }), externalUrl && {
      externalUrl: externalUrl
    }), message_id && {
      message_id: message_id
    }),
    campaign_id: campaign_id
  };
};
export var sendWelcomeNewsEvent = function sendWelcomeNewsEvent(eventType, payload) {
  var formattedPayload = buildWelcomeNewsPayload(payload);
  switch (eventType) {
    case WELCOME_NEWS_EVENT_TYPES.DISMISS_WELCOME_NEWS:
      Logger.sendEvent(EVENT_TYPES.UI_EVENT, {
        action: EVENT_ACTIONS.PRESS,
        domain: EVENT_DOMAINS.WELCOME_NEWS,
        screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].LOBBY,
        widget: EVENT_WIDGETS[EVENT_DOMAINS.GENERAL].DISMISS_BUTTON,
        welcomeNewsAction: formattedPayload
      });
      break;
    case WELCOME_NEWS_EVENT_TYPES.PRESS_WELCOME_NEWS:
      Logger.sendEvent(EVENT_TYPES.UI_EVENT, {
        action: EVENT_ACTIONS.PRESS,
        domain: EVENT_DOMAINS.WELCOME_NEWS,
        screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].LOBBY,
        widget: EVENT_WIDGETS[EVENT_DOMAINS.GENERAL].ACCEPT_BUTTON,
        welcomeNewsAction: formattedPayload
      });
      break;
    default:
      break;
  }
};